import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const utilityMoveWarehouseLocationLocaleModule: LocaleModule = {
  name: "utilityMoveWarehouseLocation",
  messages: { en: en, it: it },
};
